import {
    Navigate,
} from 'react-router-dom'
import {
    CommonRoutes,
} from 'app/enums/common.enums'

import PreBookings from 'app/common/PreBooking'
import {
    AccountManagementDomains,
} from 'app/enums/domain.enums'
import KamDashboard from './KamDashboard'
import Accounts from './Accounts'
import RegionalGroups from './RegionalGroups'
import Opportunities from './Opportunities'
import AccountLanes from './AccountLanes'
import AQuotes from './AQuotes'
import CQuotes from './CQuotes'
import SimplifiedCQuotes from './SimplifiedCQuotes'

export default {
    [AccountManagementDomains.KamDashboard]: <KamDashboard />,
    [AccountManagementDomains.Accounts]: <Accounts />,
    [AccountManagementDomains.RegionalGroups]: <RegionalGroups />,
    [AccountManagementDomains.Opportunitites]: <Opportunities />,
    [AccountManagementDomains.Lanes]: <AccountLanes />,
    [AccountManagementDomains.AQuotes]: <AQuotes />,
    [AccountManagementDomains.CQuotes]: <CQuotes />,
    [AccountManagementDomains.SimplifiedCQuotes]: <SimplifiedCQuotes />,
    [AccountManagementDomains.PreBookings]: <PreBookings />,
    [CommonRoutes.Asterisk]: <Navigate
        to={AccountManagementDomains.KamDashboard}
        replace
    />,
}
